import type { ControlProps, ListControlConfig, EditControlConfig } from './components/controls/declare'
import * as Edit from './components/controls/edit'
import * as List from './components/controls/list'
import { $consts } from 'src/plugins'

const LoadableControl = (props: ControlProps) => {
  // 列表表单控件
  if (props.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']) {
    switch (props.locateControl) {
      // 列表表单查询配置控件
      case $consts['TABLE/CONTROL_LOCATE_HEADER']:
        return <List.HeaderControl config={props.config as ListControlConfig} />
      // 列表表单行编辑控件
      case $consts['TABLE/CONTROL_LOCATE_ROW']:
        return <List.RowControl config={props.config as EditControlConfig} />
      default:
        return <div />
    }
  }
  // 编辑表单控件
  if (props.pageType === $consts['TABLE/FORM_TYPE_EDIT_PAGE']) {
    switch (props.locateControl) {
      // 编辑表单表单配置控件
      case $consts['TABLE/CONTROL_LOCATE_PAGER']:
        return <Edit.PagerControl config={props.config as EditControlConfig} />
      // 编辑表单子表行编辑控件
      case $consts['TABLE/CONTROL_LOCATE_ROW']:
        return <Edit.RowControl config={props.config as EditControlConfig} />
      default:
        return <div />
    }
  }
  return <div />
}

export default LoadableControl